<template>
    <pc-transition
        mode="out-in"
        fast
        v-on:after-leave="afterLeave">
        <div
            v-show="selected"
            v-bind:data-test-role="dataTestRole">
            <slot />
        </div>
    </pc-transition>
</template>

<script>
    export default {
        provide() {
            return { pcTab: this };
        },
        inject: ["pcTabs"],
        props: {
            // Tttle is read by pc-tabs
            title: { type: String, required: false, default: null },
            // tabId is read by pc-tabs
            tabId: { type: String, required: false, default: null },
            // icon is read by pc-tabs
            icon: { type: String, required: false, default: null },
            // isShown is read by pc-tabs
            isShown: { type: Boolean, required: false, default: true },
            // dataTestRole is read by pc-tabs
            dataTestRole: { type: String, required: false, default: null }
        },
        emits: ["selected"],
        data() {
            return {
                selected: false,
                afterLeaveCallback: null,
                selectedCallback: null
            };
        },
        watch: {
            selected: function (val) {
                if (val) {
                    this.$emit("selected", this.title);
                    if (this.selectedCallback && typeof this.selectedCallback === "function") {
                        this.selectedCallback();
                    }
                    this.selectedCallback = null;
                }
            }
        },
        created() {
            this.pcTabs?.registerTab(this);
        },
        methods: {
            afterLeave() {
                if (this.afterLeaveCallback && typeof this.afterLeaveCallback === "function") {
                    this.afterLeaveCallback();
                }
                this.afterLeaveCallback = null;
            },
            setAfterLeaveCallback(callback) {
                this.afterLeaveCallback = callback;
            },
            setSelectedCallback(callback) {
                this.selectedCallback = callback;
            }
        }
    };
</script>
